import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthTokenService } from '../services/auth-token.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authTokenService = inject(AuthTokenService);

  const token = authTokenService.getToken();

  console.log('🔒 Auth Interceptor - URL:', req.url);
  console.log('🔑 Auth Interceptor - Token exists:', !!token);
  if (token) {
    console.log('🎫 Token preview:', token.substring(0, 20) + '...');
  }

  // If token exists, clone the request and add Authorization header
  if (token) {
    console.log('✅ Adding Authorization header to request');
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(clonedReq);
  }

  console.warn('⚠️ No token available - proceeding without Authorization header');
  // If no token, proceed with original request
  return next(req);
};
